import { render, staticRenderFns } from "./DashAdminAccouning.vue?vue&type=template&id=6e818d15&scoped=true&"
import script from "./DashAdminAccouning.vue?vue&type=script&lang=js&"
export * from "./DashAdminAccouning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e818d15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
